export default "__VITE_ASSET__Byj9MWQq__"